require('./myWalletEvolutionModal.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const LineChart = require('components/d3Components/lineChart/lineChart');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const OKModal = require('components/commons/OKModal/OKModal');

class EvolutionModal extends React.Component {
    constructor(props) {
        super(props);
        this.requestEvolutionData = this.requestEvolutionData.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleEvolutionModal = this.handleEvolutionModal.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen && !this.props.isOpen) {
            this.requestEvolutionData();
        }
    }

    requestEvolutionData() {
        const { getEvolutionData, evolutionState, immBrokerCustomWalletPortfolios } = this.props;
        const selectedItem = immBrokerCustomWalletPortfolios.get('customWallets').find( item => {
            return item.get('descriptionPortfolioAccount') === evolutionState.get('selectedView');
        });
        if (!!selectedItem) {
            getEvolutionData(selectedItem.get('idPortfolioAccount'));
        }
    }

    handleRetry() {
        this.requestEvolutionData();
    }

    handleEvolutionModal() {
        this.props.onToggleEvolutionModal();
    }

    buildChart(evolutionState) {
        return (
            <div>
                <LineChart
                    width="716"
                    height="300"
                    dataset={evolutionState.get('evolutionData')}
                />
                <p className="broker-portfolio-evolution-modal__legend">
                    <FormattedText value="broker-evolutionTabLegend" />
                </p>
            </div>
        );
    }

    buildRetry() {
        return <EmptyState primaryText={formatText('broker-myWalletLostConnectionFirstLine')} iconType="nointernet-banking"/>
    }

    buildNoResult() {
        return (
            <div>
                <EmptyState primaryText={formatText('broker-evolutionTabNoResults')} iconType="search-banking"/>
                <p className="broker-portfolio-evolution-modal__legend">
                    <FormattedText value="broker-evolutionTabNoResultsDisclaimer" />
                </p>
            </div>
        )
    }

    render() {
        // TODO complete empty and error state
        const { evolutionState, immBrokerMyInvestments, onToggleEvolutionModal } = this.props;
        const { handleEvolutionModal } = this;
        const isOpen = this.props.isOpen;
        let chart;

        if (evolutionState.get('evolutionError')) {
            chart = this.buildRetry();
        } else if (immBrokerMyInvestments.get('isFetching') || evolutionState.get('evolutionIsFetching') || evolutionState.getIn(['defaultView','isFetching'])) {
            chart = <LoadingSection />;
        } else if (evolutionState.get('evolutionData').size === 0) {
            chart = this.buildNoResult();
        } else {
            chart = this.buildChart(evolutionState);
        }

        return  (
            <OKModal
                content={chart}
                footerType="action"
                isOpen={isOpen}
                onCloseCallback={handleEvolutionModal}
                onPrimaryButtonClick={onToggleEvolutionModal}
                primaryButtonText="broker-errorGoToMyWallet"
                size="large"
                title="brokerMyWallet-myWalletSeeCurrentValueEvolution"
            />
        );
    }
}

EvolutionModal.propTypes = {
    evolutionState: PropTypes.object.isRequired,
    getEvolutionData: PropTypes.func.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onToggleEvolutionModal: PropTypes.func.isRequired
};

module.exports = EvolutionModal;
